import {
  FETCH_DATASTREAM_LIST_FAILURE,
  FETCH_DATASTREAM_LIST_REQUEST,
  FETCH_DATASTREAM_LIST_SUCCESS,
} from "../actions/realtimeDatastreamList.actions";

const initialState = {
  data: null,
  loading: false,
};

const datastreamList = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DATASTREAM_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_DATASTREAM_LIST_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case FETCH_DATASTREAM_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default datastreamList;
